import React, {Component, Fragment} from 'react';

import LandingCompanyUniverse from './LandingCompanyUniverse.jsx';

import engineering1 from '../../../media/images/sub-universes/engineering/engineering_1.jpg?size=600';
import engineering2 from '../../../media/images/sub-universes/engineering/engineering_2.jpg?size=600';
import engineeringHeader from '../../../media/images/sub-universes/engineering/engineeringHeader.jpg';


const headerBrief = <Fragment>
  <p>
    Que vous recherchiez <strong>un expert, un renfort pour vos équipes ou un manager de transition en
    Ingénierie, </strong> Twineeds est la plateforme qu'il vous faut.
    Accédez directement à nos consultants ou consultez nous directement avec votre recherche.
  </p>
  <p>Accédez directement à nos consultants ou consultez nous directement avec votre recherche.</p>
</Fragment>;

const ourJobsItems = [
  {
    title: 'Ingénieurs généralistes',
    brief: '<p>Des profils généralistes pour <strong>renforcer vos équipes</strong> d\'ingénieurs : ' +
      '<strong>process et méthodes, industrialisation, qualité, production, mécanique…</strong></p>',
    img: engineering1.src,
    alt: 'Ingénieur vérifiant un outil de production dans un atelier'
  },
  {
    title: 'Ingénieurs spécialistes',
    brief: '<p>Des profils de spécialistes pour <strong>renforcer vos équipes</strong> dans des secteurs ' +
      'spécifiques : <strong>ingénieur agronome, BTP, automobile, aéronautique, spatial…</strong></p>',
    img: engineering2.src,
    alt: 'Ingénieurs comparant une pièce produite avec son croquis de production'
  },
];

const specificDifference = <Fragment>
  <strong>Une large gamme de compétences sur le secteur de l'ingénierie</strong>, quand les cabinets sont généralement
  spécialisés.
</Fragment>;

export default class LandingCompanyEngineering extends Component {
  render() {
    return <LandingCompanyUniverse
      headerBrief={headerBrief}
      headerImg={engineeringHeader.src}
      headerImgAlt="Illustration d'ingénieurs en réunion dans un atelier de production"
      metaTitle="Twineeds Ingénierie"
      metaDescription="Twineeds met en relation les entreprises avec les consultants indépendants et managers de transition en Ingénierie technique (hors IT)"
      metaOgTitle="Twineeds Manager de transition Ingénierie"
      metaOgDescription="Attirez les experts de l'Ingérierie en conseil et management de transition grâce à la plateforme Twineeds"
      ourJobsItems={ourJobsItems}
      specificDifference={specificDifference}
      title="Besoin d'ingénieurs ? (Hors IT)"
      universeCode="engineering"
    />;
  }
}
